/* Added this CanvasConstants file because it causes circular dependencies for CustomComponentNodes when placed in CanvasUtil.jsx*/
import uuid from 'uuid';

export const PRODUCTION_CANVAS_MODE = 'PRODUCTION';
export const PROGRESS_CANVAS_MODE = 'PROGRESSVIEW';
export const DEFAULT_CANVAS_MODE = 'DEFAULT';
export const VERSION_CANVAS_VIEW_MODE = 'CANVAS_VIEW';
export const PRODUCTION_CANVAS_VIEW_MODE = 'PRODUCTION_CANVAS_VIEW';
export const SAVE_PAUSE_MODE = 'SAVE_PAUSED';
export const NOTE_TYPE = 'note';
export const COMPONENT_ICON_ALT = 'canvas-svg';
export const COMPONENT_NODE_ID = 'component-node';

// When I try to get the edge keys from edge types in CanvasUtil, it creates a circular dependency
export const EDGE_TYPES = {
  LINK: 'link',
  FLOATINGLINK: 'floatingLink',
  LOOPLINK: 'loopLink',
  FORMREDIRECTLINK: 'formRedirectLink',
  NOTE_LINK: 'noteLink',
  SPLITCONVERGELINK: 'splitConvergeLink',
  GATEWAYLINK: 'gatewayLink',
};

export const isNoteCanvasElement = element =>
  element?.type === NOTE_TYPE ||
  element?.type === EDGE_TYPES.NOTE_LINK ||
  !!(
    element?.type === EDGE_TYPES.LINK &&
    element?.sourceHandle &&
    element.sourceHandle.startsWith('note')
  );

export const createLoopLink = (sourceComponentId, targetComponentId) => ({
  id: uuid(),
  source: sourceComponentId,
  target: targetComponentId,
  type: EDGE_TYPES.LOOPLINK,
});

export const createFormRedirectLink = (sourceComponentId, targetComponentId) => ({
  id: uuid(),
  source: sourceComponentId,
  target: targetComponentId,
  type: EDGE_TYPES.FORMREDIRECTLINK,
});

export const createSplitConvergeLink = (loopThroughListId, convergeThreadsId) => ({
  id: `split-converge-${loopThroughListId}-${convergeThreadsId}`,
  source: loopThroughListId,
  target: convergeThreadsId,
  type: EDGE_TYPES.SPLITCONVERGELINK,
});
